const vModelMixin = {
  props: ['value'],
  data: () => ({
    inputVal: null,
  }),
  watch: {
    value(val) {
      this.inputVal = val;
    },
    inputVal(val) {
      this.$emit('input', val);
    },
  },
  created() {
    this.inputVal = this.value;
  },
};

export default vModelMixin;
